<template>
    <section class="advertisement">
        <div class="container">
            <div class="advertisement__inner">
                    <Clock class="advertisement__clock"></Clock>
            </div>
        </div>
    </section>
</template>


<script>
import Clock from "../components/clock.vue"
export default {
    components:{Clock}
}
</script>

<style lang="scss" scoped>
.advertisement{
    margin: 20px 0px;
}
</style>